import { sendIncidentEmailUseCase } from '@src/main/modules/other_incidents/application/use-cases/send/send-incident-email.usecase';
import { Incident } from '@src/main/modules/other_incidents/domain/incident.model';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useSendIncidentEmail = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  return useMutation({
    mutationFn: async ({
      incident,
      plainText,
      htmlText,
      file,
    }: {
      incident: Incident;
      plainText: string;
      htmlText?: string;
      file?: File | null;
    }) =>
      await sendIncidentEmailUseCase(
        {
          incident,
          user,
          plainText,
          htmlText,
          file,
        },
        tokenProvider,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['incidents'] });
    },
  });
};
